const FIELD_LABELS = {
    ocr_content: 'Document Text/OCR',
    transcript: 'Video/Audio Transcript',
    notes: 'Notes',
    tag_text: 'Keywords',
    auto_tag_text: 'Auto Keywords',
    person_tag_names: 'People',
    face_names: 'Face Tags',
    event: 'Event Shown',
    iptceventid: 'Event Identifiers',
    creator_tag_text: 'Verified Creator',
    creditline: 'Credit Line',
    iptcsource: 'Source',
    iptcrights: 'Copyright Notice',
    usageterms: 'Usage Rights',
    instructions: 'Special Instructions',
    country: 'Country',
    state: 'State',
    city: 'City',
    sublocation: 'Sublocation',
    description: 'Description',
    title: 'Title',
    headline: 'Headline',
    extendeddescription: 'Extended Description',
    descriptionwriter: 'Description Writer',
    alttext: 'Alternative Text',
    tag_description: 'Keyword Description',
    persondescription: 'Person Description',
    productdescription: 'Product Description',
    aotitle: 'Artwork Name',
    aocontributiondescription: 'Art Contribution Description',
    aocontentdescription: 'Art Content Description',
    aophysicaldescription: 'Art Physical Description',
    captured_at: 'IPTC Date Created',
};

const formatFieldLabel = (field, t) => {
    if (typeof field !== 'string') return '';
    if (field.startsWith('cmf_')) return t('custom-field', 'Custom Field');
    if (FIELD_LABELS[field]) return FIELD_LABELS[field];
    return field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

export default formatFieldLabel;
